// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1bADo","content":"styles_content__134DG","checkbox":"styles_checkbox__25yuB","checkboxLabel":"styles_checkboxLabel__1LgyI"};